const messages = {
    pageTitle: 'Zlecenia na proof',
    menuTitle: 'Zlecenia na proof',

    headers: {
        number: 'Numer zlecenia',
        name: 'Nazwa zlecenia',
        customer: 'Klient',
        status: 'Status',
        createdAt: 'Data utworzenia',
        createdBy: 'Utworzone przez',
        actions: 'Akcje'
    },

    actions: {
        closeJob: 'Zamknięcie zlecenia'
    },

    errors: {
        fetchList: 'Pobranie listy zleceń na proof nie powiodło się.',
        close: 'Zamknięcie zlecenia na proof nie powiodło się.'
    },

    notifications: {
        closeSuccess: 'Zlecenie na proof zostało zamknięte.'
    }
}

export default {
    messages,
    locale: 'pl'
}
